import "./CoursesOffers.css";
import { Pagination } from "@mantine/core";
import SpecialtiesCardsContainer from "../../Specialties/SpecialtiesCardsContainer/SpecialtiesCardsContainer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAppContext } from "../../../context/AppState/AppContext";
import SuggestForm from "../SuggestForm/SuggestForm";
import { calculatePrice } from "../../../utils/calculatePrice";
import CardInfoColumn from "../../../components/CardInfo/CardInfoColumn/CardInfoColumn";
import GrandCard from "../../../components/GrandCard/GrandCard";
import { ROUTES_PATHNAME } from "../../../routes/dict";
import { formatCourseStartDate } from "../../../utils/courses-dates";
import PacksStrip from "../PacksStrip/PacksStrip";

const CoursesOffers = ({ data, packs = [], packsOnly = false, pre_inscriptionCourses, upcomingCourses, displayUpcomingCourses, isLoading, activePage, setPage, totalPages, finishedCourses, isGrand = false }) => {
    const navigate = useNavigate();
    const { isUSD, officialUSDValue } = useAppContext()

    useEffect(() => {
        setPage(1);
    }, [setPage, totalPages]);

    return (
        <div className="course-offers-container">
            {(!isLoading && (data === null || data?.length === 0) && !packs?.length) &&
                < SuggestForm />
            }

            {/* Franja "Ahorrá con packs" arriba de todo. Con el filtro PACKS, los packs van en la grilla */}
            {(!isGrand && !isLoading && !packsOnly) && <PacksStrip packs={packs} />}

            {(!isGrand && !isLoading && packsOnly && packs?.length > 0) &&
                <div style={{ marginBottom: "48px" }}>
                    <SpecialtiesCardsContainer sectionTitle="Packs disponibles">
                        {packs.map((pack) => {
                            const { name, image, price: prices } = pack.comercialInformation;
                            const academicUnits = pack.academicUnits || [];
                            const totalClasses = academicUnits.reduce((acc, au) => acc + (au.comercialInformation?.classQuantity || 0), 0);
                            return (
                                <CardInfoColumn
                                    key={pack._id}
                                    imgUrl={image}
                                    type="PACK"
                                    title={name.toLowerCase()}
                                    price={calculatePrice(prices, officialUSDValue, isUSD, pack.type)}
                                    booleanValue
                                    classes={totalClasses || "A confirmar"}
                                    date={`${academicUnits.length} cursos incluidos`}
                                    rowIn={805}
                                    buttonText="Ver pack"
                                    buttonAction={() => navigate(`/packs/${pack._id}`)}
                                />
                            );
                        })}
                    </SpecialtiesCardsContainer>
                </div>
            }

            {(!isGrand && !isLoading && pre_inscriptionCourses?.length > 0 && displayUpcomingCourses) && <div style={{ marginBottom: "48px" }}>
                <SpecialtiesCardsContainer sectionTitle="Lanzamiento de Pre Inscripciones">

                    {pre_inscriptionCourses?.map((item) => {
                        const { name, image, initialDate, price: prices, classQuantity } = item.comercialInformation;
                        const { specialties, type, _id } = item;
                        const price = calculatePrice(prices, officialUSDValue, isUSD, type);
                        return (
                            <CardInfoColumn
                                key={item._id}
                                imgUrl={image}
                                type={type}
                                tag={Array.isArray(specialties) ? null : specialties}
                                title={name.toLowerCase()}
                                price={price}
                                booleanValue
                                classes={classQuantity || "A confirmar"}
                                date={formatCourseStartDate(item)}
                                // date={initialDate || "A confirmar"}
                                buttonText="Ver curso"
                                buttonAction={() => navigate(`${ROUTES_PATHNAME.courses.href}/${_id}`)}
                            />
                        );
                    })}
                </SpecialtiesCardsContainer>
            </div>}

            {(!isGrand && !isLoading && upcomingCourses?.length > 0 && displayUpcomingCourses) &&
                <div style={{ marginBottom: "48px" }}>
                    <SpecialtiesCardsContainer sectionTitle="Próximos inicios">

                        {upcomingCourses?.map((item) => {
                            const { name, image, initialDate, price: prices, classQuantity } = item.comercialInformation;
                            const { specialties, type, _id } = item;
                            const price = calculatePrice(prices, officialUSDValue, isUSD, type);
                            return (
                                <CardInfoColumn
                                    key={item._id}
                                    imgUrl={image}
                                    type={type}
                                    tag={specialties}
                                    title={name.toLowerCase()}
                                    price={price}
                                    booleanValue
                                    classes={classQuantity}
                                    date={formatCourseStartDate(item)}
                                    // date={initialDate}
                                    buttonText="Ver curso"
                                    buttonAction={() => navigate(`${ROUTES_PATHNAME.courses.href}/${_id}`)}
                                />
                            );
                        })}
                    </SpecialtiesCardsContainer>
                </div>
            }
            {(!isLoading && data?.length > 0) &&
                <SpecialtiesCardsContainer sectionTitle={isGrand ? null : "Todas las inscripciones abiertas"}>

                    {data?.map((item) => {
                        const { name, image, initialDate, price: prices, classQuantity, classDays, classHour, } = item.comercialInformation;

                        const { specialties, type, _id, teachers } = item;
                        const price = calculatePrice(prices, officialUSDValue, isUSD, type);
                        const currentTeacher = (teachers && teachers?.length > 0) && teachers[0]

                        if (isGrand) return <GrandCard
                            teacher={currentTeacher}
                            key={item._id}
                            imgUrl={image}
                            type={type}
                            title={name.toLowerCase()}
                            classHour={classHour}
                            date={formatCourseStartDate(item)}
                            // date={initialDate}
                            classDays={classDays}
                            buttonText="Ver curso"
                            buttonAction={() => navigate(`/grand${ROUTES_PATHNAME.courses.href}/${_id}`)}
                        />

                        return (
                            <CardInfoColumn
                                key={item._id}
                                imgUrl={image}
                                type={type}
                                tag={specialties}
                                title={name.toLowerCase()}
                                price={price}
                                booleanValue
                                classes={classQuantity}
                                date={formatCourseStartDate(item)}
                                // date={initialDate}
                                rowIn={805}
                                buttonText="Ver curso"
                                buttonAction={() => navigate(`${ROUTES_PATHNAME.courses.href}/${_id}`)}
                            />
                        );
                    })}
                </SpecialtiesCardsContainer>
            }

            <div className="coursesOffers-pagination-div-container" style={{ marginBottom: '30px' }}>
                <Pagination value={activePage} onChange={setPage} total={totalPages} />
            </div>

            {(!isLoading && finishedCourses?.length > 0) &&
                <SpecialtiesCardsContainer sectionTitle="Cursos finalizados">

                    {finishedCourses?.map((item) => {
                        const { name, image } = item.comercialInformation;
                        const { specialties, type, _id } = item;

                        return (
                            <CardInfoColumn
                                key={item._id}
                                imgUrl={image}
                                type={type}
                                tag={specialties}
                                title={name.toLowerCase()}
                                rowIn={805}
                                buttonText="ver más"
                                buttonAction={() => navigate(`${ROUTES_PATHNAME.courses.href}/${_id}`)}
                            />
                        );
                    })}
                </SpecialtiesCardsContainer>
            }
        </div>
    );
};
export default CoursesOffers;
